"use strict";

define('rs/modals/training.finder/training.finder.view',['require','exports','module','rs/modals/table.finder/table.finder.view'],function (require, exports, module) {
  var TableFinderView = require('rs/modals/table.finder/table.finder.view');
  var TrainingFinderView = TableFinderView.extend({
    finderMsgs: _.extend({}, TableFinderView.prototype.finderMsgs, {
      disabled: 'Cayuse IRB supports integration with Collaborative Institutional Training Initiative (CITI), a web-based program that provides training for researchers. Training data will appear here if your institution uses CITI and if they have opted to use this integration.'
    }),
    modalClassName: 'training-finder',
    showTableContents: function showTableContents(results, enabled) {
      if (enabled) {
        this._super.apply(this, arguments);
      } else {
        this.showFinderMsg(this.finderMsgs.disabled);
        this.getFinderMsg().parent().addClass('long');
      }
    }
  });
  module.exports = TrainingFinderView;
});

